import { select, Store, StoreDef } from '@ngneat/elf';
import { State } from './state';

export abstract class Repository<S extends State> {
    readonly loading$ = this.store.pipe(select((state) => !!state.isLoading));
    readonly error$ = this.store.pipe(select((state) => state.error));

    constructor(protected readonly store: Store<StoreDef, S>) {}

    update(state: Partial<S>): void {
        this.store.update((s) => ({ ...s, ...state }));
    }

    setLoading(isLoading: boolean): void {
        this.store.update((state) => ({ ...state, isLoading }));
    }

    setError(error: any): void {
        this.store.update((state) => ({ ...state, error }));
    }

    reset(): void {
        this.store.reset();
    }

    protected getValue(): S {
        return this.store.getValue();
    }
}
